module.exports = __webpack_public_path__ + "static/media/theWheel2.0c6a7811.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theWheel2.svg
// module id = 507
// module chunks = 0